import { Activity, Car, ChartColumn, FileText, Fuel, Receipt, Users, Wrench } from 'lucide-react';

import DisplayCards from './DisplayCards';

// Cascata orizzontale: passo X ampio, passo Y ridotto.
const POSITIONS = [
  'translate-x-0 translate-y-0',
  'translate-x-20 translate-y-8',
  'translate-x-40 translate-y-16',
  'translate-x-60 translate-y-24',
  'translate-x-80 translate-y-32',
  'translate-x-100 translate-y-40',
  'translate-x-120 translate-y-48',
  'translate-x-140 translate-y-56',
];

const modules = [
  { icon: Car, title: 'Veicoli', description: 'Anagrafica e stato flotta', date: 'Flotta' },
  { icon: Users, title: 'Conducenti', description: 'Assegnazioni e patenti', date: 'Persone' },
  {
    icon: Wrench,
    title: 'Manutenzioni',
    description: 'Interventi, planning, officine',
    date: 'Officina',
  },
  {
    icon: Fuel,
    title: 'Carburante ed energia',
    description: 'Carte, ricariche, consumi',
    date: 'Energia',
  },
  { icon: Receipt, title: 'Multe', description: 'Verbali e imputazione', date: 'Conformità' },
  { icon: Activity, title: 'Telematica', description: 'Dati OBD e diagnostica', date: 'OBD' },
  {
    icon: FileText,
    title: 'Documenti',
    description: 'Assicurazioni, bolli, revisioni',
    date: 'Scadenze',
  },
  { icon: ChartColumn, title: 'Dashboard', description: 'KPI e analisi costi', date: 'Analisi' },
];

const moduleCards = modules.map(({ icon: Icon, title, description, date }, i) => ({
  className: POSITIONS[i],
  icon: <Icon aria-hidden className="size-4 text-on-emphasis" />,
  title,
  description,
  date,
}));

export default function FeatureDisplayCards() {
  return (
    <div id="moduli" className="relative">
      <div className="max-w-xl text-center lg:text-left">
        <span className="rounded-full border border-default bg-muted px-3 py-1 text-eyebrow text-link">
          Una piattaforma, tutti i moduli
        </span>
        <h2 className="mt-6 text-balance text-4xl font-semibold tracking-tight text-strong md:text-5xl">
          Tutto quello che serve per gestire la flotta
        </h2>
        <p className="mt-4 text-balance text-lg text-subtle">
          Dalla posizione live ai costi: ogni area operativa in un&apos;unica Operations Room.
        </p>
      </div>

      <div className="relative mt-8 h-64 overflow-hidden sm:h-80 lg:h-88">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="scale-[0.38] sm:scale-[0.5] lg:scale-[0.56]">
            <div className="-translate-x-60 -translate-y-28">
              <DisplayCards cards={moduleCards} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
